// extracted by mini-css-extract-plugin
export default {"gridCards":"style-module--gridCards--4TqYL"};